/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Manages the no middle name toggle for candidate forms.
     *
     * @param string middleNameValue wired value from the backend for middle name
     * @param string middleNameId    the identifier of the middle name text element
     * @param string noMiddleNameId  the identifier of the no middle name toggle element
     */
    Alpine.data('noMiddleName', (middleNameValue, middleNameId, noMiddleNameId) => ({
        /**
         * @var string wired value from the backend for middle name
         */
        middleNameValue: middleNameValue,

        /**
         * @var string the identifier of the middle name text element
         */
        middleNameId: middleNameId,

        /**
         * @var string the identifier of the no middle name toggle element
         */
        noMiddleNameId: noMiddleNameId,

        /**
         * @var object the middle name text element
         */
        middleNameElement: null,

        /**
         * @var object the no middle name toggle element
         */
        noMiddleNameElement: null,

        /**
         * Run on intialization of the alpine data.
         *
         * Since the child element gets its identifier from alpine, we must
         * wait until it's initialized with $nextTick before accessing it.
         *
         * @return void
         */
        init() {
            this.$nextTick(() => {
                this.middleNameElement   = document.getElementById(this.middleNameId);
                this.noMiddleNameElement = document.getElementById(this.noMiddleNameId);

                this.$el.addEventListener('input-changed-'+this.noMiddleNameId, this.changed.bind(this));
            });
        },

        /**
         * Action called whenever the no middle name toggle is updated.
         *
         * @param object $event the event that triggered the action
         *
         * @return void
         */
        changed($event) {
            if ($event.detail) {
                this.middleNameValue         = '';
                this.middleNameElement.value = '';
            }

            this.middleNameElement.disabled = $event.detail;
        },

        /**
         * Alpine bindings for the middle name text element.
         *
         * @return object
         */
        bindings: {
            [':disabled']() {
                if (this.noMiddleNameElement !== null) {
                    return this.noMiddleNameElement.checked;
                } else {
                    return this.middleNameElement ? this.middleNameElement.disabled : false
                }
            },
        },
    }));
});
